<div class="block-container">
  <div class="message-box">
    <p class="message-text">
      Η Elpefuture έγινε πλέον EKO Charg&Go! Δεν είναι πλέον δυνατή η ολοκλήρωση της εγγραφής σας σε αυτή την πλατφόρμα. Μπορείτε να δημιουργήσετε νέο λογαριασμό στο website <a href="https://ekosmile.gr" target="_blank">ekosmile.gr</a>
    </p>
  </div>
</div>